import { Expression } from "./abstract.expression";

export class TopExpression extends Expression 
{
    constructor(private readonly value: number) 
    {
        super();
    }

    toQuery(): string 
    {
        return `$top=${this.value}`;
    }
}
